import React, { Component } from 'react';
import icons from './../../utils/import.icons'

interface Props {
    video?: any,
    index?: any
    nombre?: any
    car?: any
    handleClose?: any
}

interface State{
    indexImage?: number,
    nameImage?: string
}

class FullVideosComponent extends Component <Props, State>{

    render() {
        return (
            <div className = "full-gallery">
                <button className = "close-img" onClick = {() => this.props.handleClose()}>
                        <img src={icons["Close"]} alt=''></img>
                </button>
                <iframe title='' className = "iframe-videos" width="1536px" height="864px" src={this.props.car.Gallery.Videos[this.props.index] +"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0"} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; loop"></iframe>
            </div>
        );
    }
}

export default FullVideosComponent;